export enum CardBrand {
  UNKNOWN = 'UNKNOWN',
  VISA = 'VISA',
  AMERICAN_EXPRESS = 'AMERICAN_EXPRESS',
  MASTERCARD = 'MASTERCARD',
  DISCOVER = 'DISCOVER',
  JCB = 'JCB',
  DINERS_CLUB = 'DINERS_CLUB',
  CARTES_BANCAIRES = 'CARTES_BANCAIRES',
  MAESTRO = 'MAESTRO',
  DE_BIJENKORF_CARD = 'DE_BIJENKORF_CARD',
}
